import { ActionTypes } from '../actions/polling'

const initialState = {}

export const polling = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.POLLING_CANCEL:
    case ActionTypes.POLLING_STATUS:
    case ActionTypes.POLLING_FAILURE: {
      if (action.status) {
        return Object.assign({}, state, {
          [action.jobId]: action.status,
        })
      }
      const nextState = Object.assign({}, state)
      delete nextState[action.jobId]
      return nextState
    }

    case ActionTypes.POLLING_BEGIN:
      return Object.assign({}, state, {
        [action.jobId]: {},
      })

    case ActionTypes.POLLING_SUCCESS: {
      const nextState = Object.assign({}, state)
      delete nextState[action.jobId]
      return nextState
    }

    default:
      return state
  }
}

export default polling
